import { SET_MESSAGE_DATA } from './types/types';

export const setMessageData = (value) => {
  return {
    type: SET_MESSAGE_DATA,
    payload: { data: value },
  };
};
